// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-segmented {
  background-color: #fff;
}

.ant-tree-select-dropdown {
  width: auto !important;
  min-width: 351px !important;
}

.ant-modal-centered .ant-modal
{
  width: max-content !important;
}`, "",{"version":3,"sources":["webpack://./src/modules/JobRoles/PageHeader/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B","sourcesContent":[".ant-segmented {\n  background-color: #fff;\n}\n\n.ant-tree-select-dropdown {\n  width: auto !important;\n  min-width: 351px !important;\n}\n\n.ant-modal-centered .ant-modal\n{\n  width: max-content !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
